export const environment = {
  production: true,
  deployment: "prod",
  internal: true,
  oidc: {
    redirectUri: `${window.location.origin}/login/callback`,
    clientId: "WAH_47cd1494-a6d1-4dd6-9ee0-61526e2212bb",
    issuer: "https://vanguard.okta.com/oauth2/austuiwbokf0be0WP357",
    scopes: ["openid", "profile", "email"],
    testing: {
      disableHttpsCheck: false,
    },
  },
  proxyServer: "https://personal1.vanguard.com/wah-wah-proxy/",
  LOGON_URL:
    "https://logon.vanguard.com/logon?TARGET_OVERRIDE=https://wealth-planning.web.vanguard.com/",
  xsrfGetCall:
    "https://wealth-management.retailadvice1p.c1.vanguard.com/api/estate-plan/tracker/status",
  appUrl: "https://weps-profile.web.vanguard.com",
  vgnUrl: "https://n4v-i.web.vanguard.com/secure-site-components.js",
  gatekeeper_url: "https://gatekeeper-service.vanguard.com/gat/toggles/VEX",
  gatekeeper_env: "PROD",
  c3Url: "https://mc3-static-assets.web.vanguard.com/vg-ccc-serverless/latest/vg-ccc-serverless.js",
  logger_environment: "production",
  consultationPrepUrl: "https://estate-planning.web.vanguard.com/consultation-prep",
  landingPageUrl: "https://estate-planning.web.vanguard.com",
  toolsPageUrl: "https://ps9-pas-tools.ecswai.retp.c1.vanguard.com/ps9-pas-tools/",
  otelCdnUrl: "https://cdn.web.vanguard.com/otel/stable/init-zone.js",
};
